import { FC } from 'react'
import { Box, Grid } from '@mui/material'
import GroupsPage from 'pages/protected/GroupsPage'

const Classes: FC = () => {
  return (
    <GroupsPage />
  )
}
export default Classes